import React, { useEffect, useState } from "react";
import image from "../../assets/images/plan.png";
export default function Development() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        top: windowWidth > 768 ? "125px" : "0px",
        marginBottom: "10vh",
        marginTop: "10vh",
        padding: windowWidth > 768 ? "80px" : "20px",
        height: "fit-content",
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "40px" }}>
        Instutional Development Plan
      </h1>

      {/* Vision Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>Vision</h2>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>
            JSS University Noida aims to become an Institution of excellence in
            imparting quality Outcome Based Education that empowers the young
            generation with Knowledge, Skills, Research, Aptitude and Ethical
            values to solve Contemporary Challenging Problems.
          </li>
        </ul>
      </section>

      {/* Mission Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>Mission</h2>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>
            Develop a platform for achieving globally acceptable level of
            intellectual acumen and technological competence.
          </li>
          <li style={{ marginBottom: "10px" }}>
            Create an inspiring ambience that raises the motivation level for
            conducting quality research.
          </li>
          <li style={{ marginBottom: "10px" }}>
            Provide an environment for acquiring ethical values and positive
            attitude.
          </li>
        </ul>
      </section>

      {/* Quality Policy Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>Quality Policy</h2>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>
            Achieve Excellence in Technical Education, Research and Consultancy
            through an Outcome Based Education.
          </li>
          <li style={{ marginBottom: "10px" }}>
            Focus on Continuous Improvement and Innovation by Benchmarking
            Against the Global Best Practices.
          </li>
        </ul>
      </section>

      {/* Alignment with NEP 2020 and UGC Guidelines */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>
          Alignment with National Education Policy (NEP) 2020 and UGC Guidelines
        </h2>
        <p>
          The National Education Policy (NEP) 2020 and the UGC Guidelines are
          both instrumental in shaping the educational framework for higher
          education institutions in India. JSS University, Noida’s Vision,
          Mission, and Quality Policy align with and support the objectives set
          forth in these policies, ensuring that the institution follows the
          national guidelines to foster holistic, multi-disciplinary, and
          innovative education.
        </p>

        <h3>1. Vision and NEP 2020</h3>
        <p>
          The Vision of JSS University, Noida, aims to become an institution of
          excellence in Outcome-Based Education (OBE), which aligns well with
          the objectives of NEP 2020. The policy emphasizes the shift to
          outcome-based learning, where the focus is on learner-centered
          education, where the outcomes of learning are measured and students
          acquire the knowledge, skills, and values necessary to solve
          real-world problems.
        </p>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>
            NEP 2020 emphasizes holistic development and interdisciplinary
            learning. JSS University’s vision aligns with this by focusing on
            developing research aptitude, skills, and ethical values, preparing
            students to face contemporary challenges. This is also in line with
            the NEP’s focus on preparing students with a global outlook while
            also fostering a sense of Indian culture and ethical grounding.
          </li>
          <li style={{ marginBottom: "10px" }}>
            The policy also encourages innovation in education, which is
            reflected in the university’s aspiration to empower students with
            skills and research capabilities that can address global challenges,
            a key principle emphasized in NEP 2020.
          </li>
        </ul>

        <h3>2. Mission and NEP 2020</h3>
        <p>
          JSS University’s Mission focuses on global intellectual and
          technological competence, the creation of an inspiring research
          environment, and the promotion of ethical values and positive
          attitudes, which closely reflect several of the key tenets of NEP
          2020:
        </p>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>
            <strong>Global Competence and Technological Excellence:</strong> NEP
            2020 calls for the enhancement of the global competitiveness of
            higher education institutions and the integration of technology in
            education. JSS University’s mission emphasizes building intellectual
            acumen and technological competence, ensuring that its graduates are
            not only well-equipped with knowledge but also prepared to use
            technology effectively in solving global problems. This aligns with
            NEP’s goal to integrate technology in learning and teaching
            processes.
          </li>
          <li style={{ marginBottom: "10px" }}>
            <strong>Research and Innovation:</strong> NEP 2020 prioritizes
            fostering an environment for research, innovation, and critical
            thinking. JSS University’s mission to create an inspiring research
            environment is directly in line with NEP 2020’s emphasis on
            research-driven education and creating a research culture. The
            policy encourages interdisciplinary research and collaboration,
            which the university's mission supports by promoting a vibrant
            research atmosphere.
          </li>
          <li style={{ marginBottom: "10px" }}>
            <strong>Ethical Values:</strong> NEP 2020 stresses the importance of
            imparting ethical values and fostering responsible citizens. JSS
            University’s focus on developing students with a strong moral
            compass and positive attitude echoes this emphasis on instilling
            ethical values in students.
          </li>
        </ul>

        <h3>3. Quality Policy and NEP 2020/UGC Guidelines</h3>
        <p>
          The Quality Policy of JSS University emphasizes excellence in
          education, continuous improvement, and innovation, which is in direct
          alignment with the principles of NEP 2020 and the UGC Guidelines.
        </p>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>
            <strong>Outcome-Based Education (OBE):</strong> NEP 2020 stresses
            the importance of shifting towards Outcome-Based Education (OBE),
            where the learning outcomes are clearly defined, and teaching is
            aligned to achieve those outcomes. JSS University’s focus on
            Outcome-Based Education directly supports this vision, as it aims to
            achieve excellence in technical education, research, and consultancy
            through this method.
          </li>
          <li style={{ marginBottom: "10px" }}>
            <strong>Continuous Improvement and Global Benchmarking:</strong> The
            focus on continuous improvement and innovation within the
            university’s Quality Policy reflects the spirit of NEP 2020, which
            calls for continuous assessment and feedback systems for improving
            the quality of teaching, learning, and research. The UGC Guidelines
            also support this through the push for institutional accreditation
            and quality audits. JSS University’s commitment to benchmarking its
            practices against global best standards is a direct response to the
            UGC’s focus on maintaining international standards in higher
            education.
          </li>
          <li style={{ marginBottom: "10px" }}>
            <strong>Innovation and Research:</strong> NEP 2020 places a strong
            emphasis on innovation and research across all academic levels. The
            university’s emphasis on innovative teaching methods and research
            outputs aligns with this. UGC also encourages higher education
            institutions to prioritize interdisciplinary and cutting-edge
            research that contributes to societal progress, which JSS University
            integrates into its mission.
          </li>
          <li style={{ marginBottom: "10px" }}>
            <strong>Integration of Technology:</strong> NEP 2020 highlights the
            importance of technology-enhanced learning (TEL) and the need to
            integrate digital learning tools into the education system. JSS
            University’s focus on technological competence and global standards
            supports NEP’s call for leveraging technology to improve learning
            outcomes.
          </li>
        </ul>

        <h3>4. UGC Guidelines</h3>
        <p>
          The UGC Guidelines provide a framework for institutions to ensure
          quality standards in higher education. These guidelines also encourage
          institutions to focus on student-centric approaches, research
          excellence, and global partnerships—all of which are encapsulated in
          JSS University’s vision, mission, and quality policy:
        </p>
        <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>
            <strong>Quality Assurance:</strong> UGC guidelines emphasize the
            importance of quality assurance mechanisms, including periodic
            reviews, self-assessment, and accreditation. JSS University’s
            commitment to continuous improvement and global benchmarking ensures
            that it meets these UGC requirements.
          </li>
          <li style={{ marginBottom: "10px" }}>
            <strong>Interdisciplinary and Holistic Education:</strong> The UGC
            guidelines encourage universities to adopt a multi-disciplinary
            approach and offer flexible programs that allow students to explore
            different fields. JSS University’s vision to provide an
            all-encompassing learning experience that integrates knowledge,
            skills, and ethical values complements this directive.
          </li>
        </ul>

        <p>
          JSS University’s Vision, Mission, and Quality Policy align closely
          with the goals outlined in NEP 2020 and the UGC Guidelines. Both the
          NEP and the UGC guidelines emphasize outcome-based education,
          innovation, research excellence, global standards, and ethical values,
          which are all core principles embedded in JSS University’s
          institutional goals. By adhering to these national policies and
          guidelines, JSS University not only ensures that it remains compliant
          with the regulatory framework but also contributes meaningfully to the
          growth and development of higher education in India.
        </p>
      </section>

      {/* Organization Structure Section */}
      <section
        style={{
          marginBottom: "40px",
          backgroundColor: "#f8f9fa",
          padding: "20px",
          borderRadius: "8px",
        }}
      >
        <h2>Organization Structure</h2>
        <p>
          The organization structure of JSS University, Noida, is designed to
          support its vision, mission, and quality policy through a hierarchical
          framework that ensures effective governance and administration.
        </p>
        <img
          src={image}
          alt="JSS University Noida Organization Structure"
          style={{
            maxWidth: "100%",
            height: "auto",
            display: "block",
            margin: "20px auto",
            border: "1px solid #ddd",
            borderRadius: "4px",
          }}
        />
      </section>
    </div>
  );
}
